<div class="profile-view" *ngIf="profile.data && profile.data.userType !== 'resident'">
    <div class="ibox detailed-view-ibox account-box">
        <div class="detailed-view-header">
            <span>My Account</span>
        </div>

        <div class="detailed-view-body">
            <div *ngIf="profile.data && !profile.spinnerShow" class="detailed-view__more-info m-t-md">
                    <input-field name="email"
                                 [ngModel]="profile.data.email"
                                 [required]="true"
                                 [title]="'Email'"
                                 [noEdit]="true">
                    </input-field>

                    <a (click)="toggleChangePasswordForm()" class="mtv-primary-color strong change-pass-link">Change password</a>

                    <change-password *ngIf="profile.isPasswordFormActive"
                                     [data]="passwordData"
                                     (onToggleShow)="toggleChangePasswordForm()">
                    </change-password>

            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>

    <div class="ibox detailed-view-ibox profile-box">
        <div class="detailed-view-header">
            <span>My Profile</span>
            <i *ngIf="profile.data && profile.data.userType === 'resident' && !residentEditMode && !profile.spinnerShow"
               class="fa fa-pencil pull-right ng-star-inserted resident-form-button"
               (click)="setResidentEditMode(true)"
               data-placement="top" data-toggle="tooltip" title="Edit"></i>
            <i *ngIf="profile.data && profile.data.userType === 'resident' && residentEditMode && !profile.spinnerShow"
               class="fa fa-times pull-right resident-form-button"
               (click)="setResidentEditMode(false)"></i>
            <i *ngIf="profile.data && profile.data.userType === 'resident' && residentEditMode && !profile.spinnerShow"
               class="fa fa-check pull-right resident-form-button"
               (click)="clickResidentInfoChangesButton()"></i>
        </div>

        <div class="detailed-view-body">
            <div class="detailed-view__more-info m-t-md">
                <form *ngIf="profile.data && !profile.spinnerShow"
                      #form="ngForm"
                      [ngClass]="{'ng-submitted': form.submitted}"
                      autocomplete="off">
                    <button id="submitResidentInfoChanges" (click)="submitResidentInfoChanges(form)" hidden></button>

                    <div class="row m-t-md m-b-md">
                        <div class="col-md-3 avatar-box" [ngClass]="{'loading': spinnerAvatar}">
                            <label class="circle-logo"
                                   [ngStyle]="{'cursor': (profile.data.userType === 'resident' && !residentEditMode) ? 'default' : ''}">
                                <input class="hidden"
                                       type="file"
                                       [disabled]="profile.data.userType === 'resident' && !residentEditMode"
                                       (change)="changeAvatar($event)"
                                       accept="image/jpeg, image/png">
                                <img [src]="profile.data.avatar || 'assets/img/user-icon.png'"/>

                                <spinner [spinnerShow]="spinnerAvatar"></spinner>
                            </label>
                            <label *ngIf="profile.data.avatar"
                                   class="delete-avatar"
                                   (click)="removeAvatar($event)"
                                   [ngClass]="{'hide': (profile.data.userType === 'resident' && !residentEditMode)}">
                                <i class="fa fa-trash"></i>
                            </label>
                        </div>

                        <div class="col-md-9 profile-main-info">
                            <div class="m-b-sm">
                                <span *ngIf="profile.data.userType === 'super_admin'" class="label admin-label">
                                    Admin
                                </span>
                                <span *ngIf="profile.data.userType === 'property_manager'" class="label manager-label">
                                    Staff
                                </span>
                                <span *ngIf="profile.data.userType === 'resident'" class="label residents-label">
                                    Resident
                                </span>
                            </div>

                            <input-field *ngIf="profile.data.userType !== 'resident'"
                                         [ngModel]="profile.data.fullName"
                                         name="fullName"
                                         [required]="true"
                                         [class]="'strong full-name-field'"
                                         (update)="update({fullName: form.value.fullName})">
                            </input-field>
                            <div *ngIf="profile.data.userType === 'resident'">
                                <input-field *ngIf="!residentEditMode"
                                             [ngModel]="profile.data.fullName"
                                             name="fullName"
                                             [required]="true"
                                             [noEdit]="true"
                                             [class]="'strong full-name-field'"
                                             (update)="update({fullName: form.value.fullName})">
                                </input-field>
                                <input-field *ngIf="residentEditMode"
                                             [ngModel]="profile.data.fullName"
                                             name="fullName"
                                             [required]="true"
                                             [editOnly]="true"
                                             [class]="'strong full-name-field'"
                                             (update)="update({fullName: form.value.fullName})">
                                </input-field>
                            </div>

                            <div *ngIf="getPrimaryPhone(profile.data.phones)">
                                <div class="row">
                                    <div class="dv-value col-sm-12">
                                        <i class="fa fa-phone  m-r-sm"> </i>
                                        <span> {{ getPrimaryPhone(profile.data.phones) }} </span>
                                    </div>
                                </div>
                            </div>

                            <resident-email-field [ngModel]="profile.data.email"
                                                  [value]="profile.data.email"
                                                  name="email"
                                                  [noEdit]="true"
                                                  [icon]="'fa fa-envelope'"
                                                  (update)="update({email: form.value.email})">
                            </resident-email-field>
                        </div>
                    </div>

                    <phone-field *ngIf="profile.data.userType !== 'resident'"
                                 #phoneField
                                 [ngModel]="profile.data.phones"
                                 name="phones"
                                 [userId]="profile.data.id"
                                 (update)="update({phones: form.value.phones})"
                                 (reset)="resetPhones($event)">
                    </phone-field>
                    <div *ngIf="profile.data.userType === 'resident'">
                        <phone-field *ngIf="!residentEditMode"
                                     [noEdit]="true"
                                     #phoneField
                                     [ngModel]="profile.data.phones"
                                     name="phones"
                                     [userId]="profile.data.id"
                                     (update)="update({phones: form.value.phones})"
                                     (reset)="resetPhones($event)">
                        </phone-field>
                        <phone-field *ngIf="residentEditMode"
                                     [editOnly]="true"
                                     #phoneField
                                     [ngModel]="profile.data.phones"
                                     name="phones"
                                     [userId]="profile.data.id"
                                     (update)="update({phones: form.value.phones})"
                                     (reset)="resetPhones($event)">
                        </phone-field>
                    </div>
                    <div *ngIf="profile.data.userType === 'resident'" class="hide-edit-buttons">
                        <address-field *ngIf="!residentEditMode"
                                       [noEdit]="true"
                                       [multiple]="true"
                                       [ngModel]="profile.data.addresses"
                                       name="addresses"
                                       [value]="profile.data.addresses"
                                       [userId]="profile.data.id"
                                       (update)="update({addresses: form.value.addresses})"
                                       (reset)="resetAddress($event)">
                        </address-field>
                        <address-field *ngIf="residentEditMode"
                                       [editOnly]="true"
                                       [multiple]="true"
                                       [ngModel]="profile.data.addresses"
                                       name="addresses"
                                       [value]="profile.data.addresses"
                                       [userId]="profile.data.id"
                                       (update)="update({addresses: form.value.addresses})"
                                       (reset)="resetAddress($event)">
                        </address-field>
                    </div>

                    <hr>

                    <datetime-field *ngIf="profile.data.userType !== 'resident'"
                                    name="dateOfBirth"
                                    [classLabel]="'dv-label col-sm-3 strong'"
                                    [classValueBox]="'dv-value col-sm-9'"
                                    [classValueEditBox]="'dv-value-edit col-sm-9'"
                                    [title]="'DOB'"
                                    ngModel
                                    [value]="profile.data.dateOfBirth"
                                    (update)="update({dateOfBirth: form.value.dateOfBirth})">
                    </datetime-field>
                    <div *ngIf="profile.data.userType === 'resident'" class="hide-edit-buttons">
                        <datetime-field *ngIf="!residentEditMode"
                                        [noEdit]="true"
                                        name="dateOfBirth"
                                        [classLabel]="'dv-label col-sm-3 strong'"
                                        [classValueBox]="'dv-value col-sm-9'"
                                        [classValueEditBox]="'dv-value-edit col-sm-9'"
                                        [title]="'DOB'"
                                        [ngModel]="profile.data.dateOfBirth"
                                        [value]="profile.data.dateOfBirth"
                                        (update)="update({dateOfBirth: form.value.dateOfBirth})">
                        </datetime-field>
                        <datetime-field *ngIf="residentEditMode"
                                        [editOnly]="true"
                                        name="dateOfBirth"
                                        [classLabel]="'dv-label col-sm-3 strong'"
                                        [classValueBox]="'dv-value col-sm-9'"
                                        [classValueEditBox]="'dv-value-edit col-sm-9'"
                                        [title]="'DOB'"
                                        [ngModel]="profile.data.dateOfBirth"
                                        [value]="profile.data.dateOfBirth"
                                        (update)="update({dateOfBirth: form.value.dateOfBirth})">
                        </datetime-field>
                    </div>

                    <hr *ngIf="profile.data.userType === 'resident'">

                    <div *ngIf="profile.data.userType === 'resident'">
                        <boolean-field *ngIf="!residentEditMode"
                                       [ngModel]="profile.data.consent ? profile.data.consent.isSigned : 0"
                                       name="consent"
                                       [title]="'Consent'"
                                       [required]="true"
                                       [noEdit]="true"
                                       [class]="'strong full-name-field'"
                                       (update)="changeWaiverSettings($event)">
                        </boolean-field>
                        <div class="row m-b-xs" *ngIf="residentEditMode">
                            <div class="dv-label col-sm-3 strong">Consent</div>

                            <div class="dv-value-edit col-sm-9">
                                <select [ngModel]="profile.data.consent ? profile.data.consent.isSigned : 0"
                                        name="consent"
                                        (change)="changeWaiverSettings($event)"
                                        class="form-control">
                                    <option [value]="1">Yes</option>
                                    <option [value]="0">No</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <hr *ngIf="profile.data.userType !== 'resident'">

                    <textarea-field *ngIf="profile.data.userType !== 'resident'"
                                    [ngModel]="profile.data.aboutMe"
                                    name="aboutMe"
                                    [value]="profile.data.aboutMe"
                                    [maxLength]="255"
                                    [title]="'About me'"
                                    (update)="update({aboutMe: form.value.aboutMe})">
                    </textarea-field>

                    <div *ngIf="profile.data.userType === 'property_manager' || profile.data.userType === 'super_admin'"
                         class="m-b-sm signature-header"
                         (dblclick)="initSummernote()">
                        <label>SIGNATURE</label>
                        <div *ngIf="signatureEdit" class="dv-value-edit">
                            <button (click)="submitSignature()">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" (click)="cancelSignatureEdit()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <i class="fa fa-pencil pull-right"
                           (click)="initSummernote()"
                           *ngIf="!signatureEdit"
                           data-placement="top" data-toggle="tooltip" title="Edit">
                        </i>
                    </div>
                    <div (dblclick)="initSummernote()"
                         class="signature-wrapper"
                         *ngIf="profile.data.userType === 'property_manager' || profile.data.userType === 'super_admin'">
                        <div *ngIf="signatureEdit" class="form-group" id="summernote">{{profile.data.signature}}</div>
                        <div *ngIf="!signatureEdit" [innerHTML]="profile.data.signature | safeHtml"></div>
                    </div>
                </form>
            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>
</div>
<div class="mainPartPage profile-view resident" *ngIf="profile.data && profile.data.userType === 'resident'">
    <div class="ibox detailed-view-ibox account-box" [ngClass]="{'closed': !accountExpanded}">
        <div class="detailed-view-header">
            <i class="fa {{!accountExpanded ? 'fa-chevron-right' : 'fa-chevron-down'}}"
               (click)="accountExpanded = !accountExpanded"></i>
            <span class="header-text">My Account</span>
        </div>

        <div class="detailed-view-body" *ngIf="accountExpanded">
            <div *ngIf="profile.data && !profile.spinnerShow" class="detailed-view__more-info m-t-md">
                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Name</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!accountEditMode">{{accountService.user?.fullName}}</span>
                        <!--<input *ngIf="accountEditMode" class="form-control" name="fullName" [ngModel]="profile.data.userProfile.fullName" maxlength="255">-->
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Email</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!accountEditMode">{{profile.data.userProfile.email}}</span>
                        <!--<input *ngIf="accountEditMode" class="form-control" name="email" [ngModel]="profile.data.userProfile.email" maxlength="255">-->
                    </div>
                </div>

                <a (click)="toggleChangePasswordForm()" class="mtv-primary-color strong change-pass-link">Change password</a>

                <change-password *ngIf="profile.isPasswordFormActive"
                                 [data]="passwordData"
                                 (onToggleShow)="toggleChangePasswordForm()">
                </change-password>

            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>

    <div class="ibox detailed-view-ibox profile-box" [ngClass]="{'closed': !userProfileExpanded}">
        <div class="detailed-view-header">
            <i class="fa {{!userProfileExpanded ? 'fa-chevron-right' : 'fa-chevron-down'}}"
               (click)="userProfileExpanded = !userProfileExpanded"></i>
            <span class="header-text">My Profile</span>
            <span class="m-l-sm label residents-label">Resident</span>
            <span class="m-l-sm label label-pending" *ngIf="hasPendingChanges('userProfile')">Pending Approval</span>
            <i *ngIf="!userProfileEditMode"
               class="fa fa-pencil pull-right mtv-primary-color"
               aria-hidden="true"
               (click)="turnEditModeOn('userProfile')">
            </i>
        </div>

        <div class="detailed-view-body" *ngIf="userProfileExpanded">
            <div class="detailed-view__more-info m-t-sm">
                <div class="row m-b-sm">
                    <div class="col-md-3" style="line-height: 90px;">
                        <label>Profile Image</label>
                    </div>
                    <div class="col-md-3 avatar-box resident-avatar" [ngClass]="{'loading': spinnerAvatar}">
                        <label class="circle-logo" [ngStyle]="{'cursor': !userProfileEditMode ? 'default' : ''}">
                            <input class="hidden"
                                   type="file"
                                   [disabled]="!userProfileEditMode"
                                   (change)="changeAvatar($event)"
                                   accept="image/jpeg, image/png">
                            <img [src]="profile.data.avatar || 'assets/img/user-icon.png'"/>

                            <spinner [spinnerShow]="spinnerAvatar"></spinner>
                        </label>
                        <label *ngIf="profile.data.avatar"
                               class="delete-avatar"
                               (click)="removeAvatar($event)"
                               [ngClass]="{'hide': !userProfileEditMode}">
                            <i class="fa fa-trash"></i>
                        </label>
                    </div>
                </div>

                <div class="profile-main-info">
                    <div class="row m-b-sm m-t-sm">
                        <div class="col-md-3">
                            <label>Name</label>
                        </div>
                        <div class="col-md-9">
                            <div *ngIf="!userProfileEditMode" class="m-b-custom">
                                {{profile.data.userProfile?.fullName ? profile.data.userProfile?.fullName : '-'}}
                            </div>
                            <input *ngIf="userProfileEditMode"
                                   class="form-control"
                                   name="userProfileFullName"
                                   maxlength="255"
                                   [(ngModel)]="profile.data.userProfile.fullName">
                        </div>
                    </div>

                    <!--<div class="row m-b-sm">-->
                        <!--<div class="col-md-12">-->
                            <!--<resident-email-field-->
                                <!--*ngIf="!userProfileEditMode"-->
                                <!--[ngModel]="profile.data.userProfile.email"-->
                                <!--[value]="profile.data.userProfile.email"-->
                                <!--name="userProfileEmail"-->
                                <!--[noEdit]="true"-->
                                <!--[icon]="'fa fa-envelope'"-->
                                <!--(update)="update({email: form.value.userProfileEmail})">-->
                            <!--</resident-email-field>-->
                            <!--<resident-email-field-->
                                <!--*ngIf="userProfileEditMode"-->
                                <!--[ngModel]="profile.data.userProfile.email"-->
                                <!--[value]="profile.data.userProfile.email"-->
                                <!--name="userProfileEmail"-->
                                <!--[editOnly]="true"-->
                                <!--[openedForEdit]="true"-->
                                <!--[icon]="'fa fa-envelope'"-->
                                <!--(update)="update({email: form.value.userProfileEmail})">-->
                            <!--</resident-email-field>-->
                        <!--</div>-->
                    <!--</div>-->
                    <div class="row hide-edit-buttons">
                        <div class="col-md-3">
                            <label style="line-height: 25px;">Phone</label>
                        </div>
                        <div class="col-md-9">
                            <phone-field *ngIf="!userProfileEditMode && profile.data.phones?.length > 0"
                                         [ngModel]="profile.data.phones"
                                         name="userProfilePhones"
                                         [title]="'Phone'"
                                         [class]="'text-transform-none thirteen-pixel-text'"
                                         [noEdit]="true"
                                         [userId]="profile.data.id">
                            </phone-field>
                            <span *ngIf="!userProfileEditMode && profile.data.phones?.length < 1"> - </span>
                            <phone-field *ngIf="userProfileEditMode"
                                         [ngModel]="profile.data.phones"
                                         name="userProfilePhones"
                                         [title]="'Phone'"
                                         [class]="'text-transform-none thirteen-pixel-text'"
                                         [editOnly]="true"
                                         [hideEmptyArrayLabel]="true"
                                         [userId]="profile.data.id">
                            </phone-field>
                        </div>
                    </div>
                    <div class="hide-edit-buttons m-b-sm">
                        <address-field *ngIf="!userProfileEditMode"
                                       [noEdit]="true"
                                       [multiple]="true"
                                       [ngModel]="profile.data.addresses"
                                       name="addresses"
                                       [title]="'Address'"
                                       [class]="'text-transform-none thirteen-pixel-text'"
                                       [value]="profile.data.addresses"
                                       [userId]="profile.data.id"
                                       (update)="update({addresses: form.value.addresses})"
                                       (reset)="resetAddress($event)">
                        </address-field>
                        <address-field *ngIf="userProfileEditMode"
                                       [editOnly]="true"
                                       [multiple]="true"
                                       [ngModel]="profile.data.addresses"
                                       name="addresses"
                                       [title]="'Address'"
                                       [class]="'text-transform-none thirteen-pixel-text'"
                                       [value]="profile.data.addresses"
                                       [userId]="profile.data.id"
                                       (update)="update({addresses: form.value.addresses})"
                                       (reset)="resetAddress($event)">
                        </address-field>
                    </div>
                    <!--<div class="row m-b-xs hide-edit-buttons directory-add-modal-date-field DOB-field">
                        <div class="col-md-3">
                            <label>Date of Birth</label>
                        </div>
                        <div class="col-md-9">
                            <span *ngIf="!userProfileEditMode">
                                {{profile.data.userProfile?.dateOfBirth | mccDate}}
                            </span>
                            <mat-form-field *ngIf="userProfileEditMode">
                                <input matInput
                                       [(ngModel)]="profile.data.userProfile.dateOfBirth"
                                       name="userProfileDateOfBirth"
                                       (focus)="userProfileDateOfBirthPicker.open()"
                                       (click)="userProfileDateOfBirthPicker.open()"
                                       [matDatepicker]="userProfileDateOfBirthPicker"
                                       placeholder="Choose a date">
                                <mat-datepicker-toggle matSuffix [for]="userProfileDateOfBirthPicker"></mat-datepicker-toggle>
                                <mat-datepicker #userProfileDateOfBirthPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>-->
                </div>
                <div class="buttons-row" *ngIf="userProfileEditMode" style="margin-bottom: 7px;">
                    <button type="button"
                            class="btn btn-outline-primary mtv-primary-color"
                            [disabled]="disabledSubmit"
                            (click)="turnEditModeOff('userProfile')">
                        Cancel
                    </button>
                    <button type="button"
                            class="btn btn-primary submit-btn m-l-sm"
                            [disabled]="disabledSubmit"
                            (click)="updateSection('userProfile')">
                        Save
                    </button>
                </div>
            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>

    <div class="ibox detailed-view-ibox profile-box" [ngClass]="{'closed': !emergencyContactsExpanded}">
        <div class="detailed-view-header">
            <i class="fa {{!emergencyContactsExpanded ? 'fa-chevron-right' : 'fa-chevron-down'}}"
               [ngStyle]="{'visibility': !profile.data.userProfile || !profile.data.userProfile.emergencyContacts ? 'hidden' : 'visible'}"
               (click)="emergencyContactsExpanded = !emergencyContactsExpanded">
            </i>
            <span class="header-text">Emergency Contacts</span>
            <span class="m-l-sm label label-pending" *ngIf="hasPendingChanges('emergencyContacts')">
                Pending Approval
            </span>
            <i *ngIf="!emergencyContactsEditMode"
               class="fa fa-pencil pull-right mtv-primary-color"
               aria-hidden="true"
               (click)="turnEditModeOn('emergencyContacts')">
            </i>
        </div>

        <div class="detailed-view-body m-t-sm" *ngIf="emergencyContactsExpanded && profile.data.userProfile">
            <div class="row m-b-xs"
                 *ngIf="!profile.data.userProfile.emergencyContacts?.length && !emergencyContactsEditMode">
                <div class="dv-value col-sm-12">
                    <span>-</span>
                </div>
            </div>

            <div class="row {{!last ? 'm-b-md' : ''}}"
                 *ngFor="let item of profile.data.userProfile.emergencyContacts; let i = index; let first = first; let last = last;">
                <div class="dv-value col-sm-12" [class.hidden]="emergencyContactsEditMode">
                    <div>{{item.name}}</div>
                    <div>{{item.phone}}</div>
                    <div>{{item.email}}</div>
                    <div>{{item.relation}}</div>
                    <div>
                        <pre>{{item.note}}</pre>
                    </div>
                </div>

                <div class="dv-value-edit dv-phone-block" [class.hidden]="!emergencyContactsEditMode" style="display: block;">
                    <div class="col-sm-2 m-b-sm">Name</div>
                    <div class="col-sm-10 m-b-sm">
                        <input class="form-control" [(ngModel)]="item.name" name="name[{{i}}]" maxlength="255">
                    </div>

                    <div class="col-sm-2 m-b-sm">Phone</div>
                    <div class="col-sm-10 m-b-sm">
                        <input class="form-control" [(ngModel)]="item.phone" name="phone[{{i}}]" maxlength="255">
                    </div>

                    <div class="col-sm-2 m-b-sm">Email</div>
                    <div class="col-sm-10 m-b-sm">
                        <input class="form-control" [(ngModel)]="item.email" name="email[{{i}}]" maxlength="255">
                    </div>

                    <div class="col-sm-2 m-b-sm">Relation</div>
                    <div class="col-sm-10 m-b-sm">
                        <input class="form-control" [(ngModel)]="item.relation" name="relation[{{i}}]" maxlength="255">
                    </div>

                    <div class="col-sm-12 m-b-sm">
                        <div class="radio-box" style="padding: 0;">
                            <input type="radio"
                                   name="primary[{{i}}]"
                                   [checked]="item.isPrimary"
                                   (click)="updatePrimary(i)"
                                   [value]="i"
                                   id="primary-{{i}}">
                            <label for="primary-{{i}}"> Primary</label>
                        </div>
                    </div>

                    <div class="col-sm-2 m-b-sm">Note</div>
                    <div class="col-sm-10 m-b-sm">
                        <textarea class="form-control" name="note[{{i}}]" maxlength="255" [(ngModel)]="item.note"></textarea>
                    </div>
                    <div class="col-sm-12 display-flex m-b-sm">
                        <button type="button" (click)="remove(i)">
                            <i class="fa fa-trash m-n" style="opacity: 1;"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="emergencyContactsEditMode">
                <div class="col-sm-12">
                    <i class="icon-plus pull-right" (click)="addNewContact()" data-toggle="tooltip"
                       data-placement="top" title="Add New Address" style="opacity: 1;"></i>
                </div>
            </div>

            <div class="buttons-row" *ngIf="emergencyContactsEditMode" style="margin-bottom: 7px;">
                <button type="button"
                        class="btn btn-outline-primary mtv-primary-color"
                        [disabled]="disabledSubmit"
                        (click)="turnEditModeOff('emergencyContacts')">
                    Cancel
                </button>
                <button type="button"
                        class="btn btn-primary submit-btn m-l-sm"
                        [disabled]="disabledSubmit"
                        (click)="updateSection('emergencyContacts')">
                    Save
                </button>
            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>

    <div class="ibox detailed-view-ibox profile-box" [ngClass]="{'closed': !vehiclesExpanded}">
        <div class="detailed-view-header">
            <i class="fa {{!vehiclesExpanded ? 'fa-chevron-right' : 'fa-chevron-down'}}"
               [ngStyle]="{'visibility': (!profile.data.vehicles || profile.data.vehicles.length < 1) ? 'hidden' : 'visible'}"
               (click)="vehiclesExpanded = !vehiclesExpanded"></i>
            <span class="header-text">Vehicles</span>
            <span class="m-l-sm label label-pending" *ngIf="hasPendingChanges('vehicles')">Pending Approval</span>
            <i *ngIf="!vehiclesEditMode"
               class="fa fa-pencil pull-right mtv-primary-color"
               aria-hidden="true"
               (click)="turnEditModeOn('vehicles')"></i>
        </div>

        <div class="detailed-view-body" *ngIf="vehiclesExpanded">
            <div *ngFor="let vehicle of profile.data.vehicles; let index = index; let last = last;"
                 class="detailed-view__more-info m-t-sm"
                 [ngStyle]="{'border-bottom': profile.data.vehicles.length > 0 && !last ? '1px solid #dedfe0' : 'none'}">
                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Make</label>
                    </div>
                    <div class="col-md-9">
                        <div *ngIf="!vehiclesEditMode" class="pending-label-row">
                            <div class="item">{{vehicle.brand}}</div>
                            <span class="m-l-sm label label-pending" *ngIf="hasPendingChanges('vehiclesItem', vehicle)">
                                Pending Approval
                            </span>
                        </div>
                        <input *ngIf="vehiclesEditMode"
                               class="form-control"
                               name="vehicleMake"
                               maxlength="255"
                               [(ngModel)]="vehicle.brand">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Model</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!vehiclesEditMode">{{vehicle.model}}</span>
                        <input *ngIf="vehiclesEditMode"
                               class="form-control"
                               name="vehicleModel"
                               maxlength="255"
                               [(ngModel)]="vehicle.model">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>License Plate</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!vehiclesEditMode">{{vehicle.licensePlate}}</span>
                        <input *ngIf="vehiclesEditMode"
                               class="form-control"
                               name="licensePlate"
                               maxlength="255"
                               required
                               [(ngModel)]="vehicle.licensePlate">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Year</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!vehiclesEditMode">{{vehicle.year}}</span>
                        <input *ngIf="vehiclesEditMode"
                               class="form-control"
                               name="vehicleYear"
                               maxlength="255"
                               [(ngModel)]="vehicle.year">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Color</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!vehiclesEditMode">{{vehicle.color}}</span>
                        <input *ngIf="vehiclesEditMode"
                               class="form-control"
                               name="vehicleColor"
                               maxlength="255"
                               [(ngModel)]="vehicle.color">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Notes</label>
                    </div>
                    <div class="col-md-9">
                        <pre *ngIf="!vehiclesEditMode">{{vehicle.note}}</pre>
                        <textarea *ngIf="vehiclesEditMode"
                                  class="form-control"
                                  name="vehicleNotes"
                                  maxlength="255"
                                  [(ngModel)]="vehicle.note"></textarea>
                    </div>
                </div>

                <div class="m-b-sm text-right" *ngIf="vehiclesEditMode">
                    <i class="fa fa-plus mtv-primary-color clickable" (click)="addNewItem('vehicles', index)"></i>
                    <i class="fa fa-trash mtv-primary-color" style="opacity: 1;"
                       (click)="removeItem(profile.data.vehicles, index)"></i>
                </div>
            </div>
            <div class="buttons-row" *ngIf="vehiclesEditMode">
                <button type="button"
                        class="btn btn-outline-primary mtv-primary-color"
                        [disabled]="disabledSubmit"
                        (click)="turnEditModeOff('vehicles')">
                    Cancel
                </button>
                <button type="button"
                        class="btn btn-primary submit-btn m-l-sm"
                        [disabled]="disabledSubmit"
                        (click)="updateSection('vehicles')">
                    Save
                </button>
            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>

    <div class="ibox detailed-view-ibox profile-box" [ngClass]="{'closed': !petsExpanded}">
        <div class="detailed-view-header">
            <i class="fa {{!petsExpanded ? 'fa-chevron-right' : 'fa-chevron-down'}}"
               [ngStyle]="{'visibility': (!profile.data.pets || profile.data.pets.length < 1) ? 'hidden' : 'visible'}"
               (click)="petsExpanded = !petsExpanded"></i>
            <span class="header-text">Pets</span>
            <span class="m-l-sm label label-pending" *ngIf="hasPendingChanges('pets')">Pending Approval</span>
            <i *ngIf="!petsEditMode"
               class="fa fa-pencil pull-right mtv-primary-color"
               aria-hidden="true"
               (click)="turnEditModeOn('pets')"></i>
        </div>

        <div class="detailed-view-body" *ngIf="petsExpanded">
            <div *ngFor="let pet of profile.data.pets; let index = index; let last = last;"
                 class="detailed-view__more-info m-t-sm"
                 [ngStyle]="{'border-bottom': profile.data.pets.length > 0 && !last ? '1px solid #dedfe0' : 'none'}">
                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Pet Type</label>
                    </div>
                    <div class="col-md-9">
                        <div *ngIf="!petsEditMode" class="pending-label-row">
                            <div class="item">{{getPetTypeName(pet.petType)}}</div>
                            <span class="m-l-sm label label-pending" *ngIf="hasPendingChanges('petsItem', pet)">
                                Pending Approval
                            </span>
                        </div>
                        <select *ngIf="petsEditMode" class="form-control" name="petType" [(ngModel)]="pet.petType" required>
                            <option value="" hidden></option>
                            <option *ngFor="let petType of profile.petTypes" [value]="petType.id">
                                {{petType.name}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Name</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!petsEditMode">{{pet.name}}</span>
                        <input *ngIf="petsEditMode"
                               class="form-control"
                               name="petName"
                               [(ngModel)]="pet.name"
                               maxlength="255"
                               required>
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Weight</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!petsEditMode">{{pet.weight}}</span>
                        <input *ngIf="petsEditMode"
                               class="form-control"
                               name="petWeight"
                               [(ngModel)]="pet.weight"
                               maxlength="255">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Height</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!petsEditMode">{{pet.height}}</span>
                        <input *ngIf="petsEditMode"
                               class="form-control"
                               name="petHeight"
                               [(ngModel)]="pet.height"
                               maxlength="255">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Breed</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!petsEditMode">{{pet.breed}}</span>
                        <input *ngIf="petsEditMode"
                               class="form-control"
                               name="petBreed"
                               [(ngModel)]="pet.breed"
                               maxlength="255">
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Date of Birth</label>
                    </div>
                    <div class="col-md-9 hide-edit-buttons directory-add-modal-date-field DOB-field">
                        <span *ngIf="!petsEditMode">{{pet.dateOfBirth | mccDate}}</span>
                        <mat-form-field *ngIf="petsEditMode" style="width: 100%">
                            <input matInput
                                   [(ngModel)]="pet.dateOfBirth"
                                   name="petDOB"
                                   (focus)="petDOB.open()"
                                   (click)="petDOB.open()"
                                   [matDatepicker]="petDOB"
                                   placeholder="Choose a date">
                            <mat-datepicker-toggle matSuffix [for]="petDOB"></mat-datepicker-toggle>
                            <mat-datepicker #petDOB></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-3">
                        <label>Notes</label>
                    </div>
                    <div class="col-md-9">
                        <span *ngIf="!petsEditMode">{{pet.note}}</span>
                        <textarea *ngIf="petsEditMode"
                                  class="form-control"
                                  name="petNotes"
                                  [(ngModel)]="pet.note"
                                  maxlength="255">
                        </textarea>
                    </div>
                </div>

                <div class="m-b-sm text-right" *ngIf="petsEditMode">
                    <i class="fa fa-plus mtv-primary-color clickable" (click)="addNewItem('pets', index)"></i>
                    <i class="fa fa-trash mtv-primary-color" style="opacity: 1;"
                       (click)="removeItem(profile.data.pets, index)"></i>
                </div>
            </div>
            <div class="buttons-row" *ngIf="petsEditMode">
                <button type="button"
                        class="btn btn-outline-primary mtv-primary-color"
                        [disabled]="disabledSubmit"
                        (click)="turnEditModeOff('pets')">
                    Cancel
                </button>
                <button type="button"
                        class="btn btn-primary submit-btn m-l-sm"
                        [disabled]="disabledSubmit"
                        (click)="updateSection('pets')">
                    Save
                </button>
            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>

    <div class="ibox detailed-view-ibox profile-box" [ngClass]="{'closed': !consentWaiversExpanded}">
        <div class="detailed-view-header">
            <i class="fa {{!consentWaiversExpanded ? 'fa-chevron-right' : 'fa-chevron-down'}}"
               (click)="consentWaiversExpanded = !consentWaiversExpanded"></i>
            <span class="header-text">Consents/Waivers</span>
        </div>

        <div class="detailed-view-body" *ngIf="consentWaiversExpanded">
            <div *ngIf="profile.data && !profile.spinnerShow" class="detailed-view__more-info m-t-md">
                <div class="row m-b-sm" *ngIf="profile.currentCorporationSettings.useEmailWaiver">
                    <div class="col-md-12">
                        <i *ngIf="profile.data.emailWaiverSigned" class="icon-check"></i>
                        <i *ngIf="!profile.data.emailWaiverSigned" class="icon-close"></i>
                        <label class="clickable-text" style="cursor: default;">Email Notifications</label>
                    </div>
                </div>

                <div class="row m-b-sm" *ngIf="profile.currentCorporationSettings.useParcelsWaiver">
                    <div class="col-md-12">
                        <i *ngIf="profile.data.parcelWaiverSigned" class="icon-check"></i>
                        <i *ngIf="!profile.data.parcelWaiverSigned" class="icon-close"></i>
                        <label class="clickable-text" style="cursor: default;">Parcel Waiver</label>
                    </div>
                </div>

                <div class="row m-b-sm" *ngIf="profile.currentCorporationSettings.useKeyWaiver">
                    <div class="col-md-12">
                        <i *ngIf="profile.data.keyWaiverSigned" class="icon-check"></i>
                        <i *ngIf="!profile.data.keyWaiverSigned" class="icon-close"></i>
                        <label class="clickable-text" style="cursor: default;">Key Waiver</label>
                    </div>
                </div>

                <div class="row m-b-sm">
                    <div class="col-md-12">
                        <i *ngIf="profile.data.consent?.isSigned" class="icon-check"></i>
                        <i *ngIf="!profile.data.consent?.isSigned" class="icon-close"></i>
                        <label class="clickable-text" (click)="profile.showChangeWaiverSettingsModal = true">
                            Electronic Communication Consent
                        </label>
                    </div>
                </div>
            </div>
            <spinner [spinnerShow]="!profile.data || profile.spinnerShow"></spinner>
        </div>
    </div>
</div>
<change-waiver-settings-modal *ngIf="profile.showChangeWaiverSettingsModal"></change-waiver-settings-modal>



// WEBPACK FOOTER //
// /app/src/app/views/profile/profile.component.html